import { random } from '../utils/random.js';

/** Pool of default ship names, drawn without repeats until exhausted then recycled. */
const SHIP_NAMES = [
  // Classic nautical
  'Horizon', 'Meridian', 'Polaris', 'Vanguard', 'Endeavour',
  'Resolute', 'Intrepid', 'Valiant', 'Corsair', 'Tempest',
  'Trident', 'Sovereign', 'Voyager', 'Mariner', 'Venture',
  'Osprey', 'Albatross', 'Pelican', 'Cormorant', 'Petrel',
  'Compass Rose', 'North Star', 'Trade Wind', 'Sea Breeze', 'Gulf Stream',
  'Tidal Force', 'Riptide', 'Monsoon', 'Sirocco', 'Mistral',
  // Geography / seas
  'Pacific Dawn', 'Atlantic Grace', 'Baltic Pride', 'Nordic Spirit', 'Caspian',
  'Aegean Star', 'Coral Sea', 'Arafura', 'Benguela', 'Kuroshio',
  'Malacca', 'Bosphorus', 'Dardanelles', 'Sunda', 'Magellan',
  'Cape Horn', 'Drake', 'Weddell', 'Labrador', 'Bengala',
  // Merchant marine style
  'Iron Will', 'Steel Tide', 'Silver Anchor', 'Golden Keel', 'Copper Ridge',
  'Blue Horizon', 'Red Ensign', 'White Star', 'Green Cape', 'Black Pearl',
  'Fair Haven', 'Good Hope', 'Safe Passage', 'True North', 'Free Spirit',
  'Sea Lion', 'Sea Hawk', 'Sea Wolf', 'Sea Fox', 'Sea Eagle',
  // Modern commercial
  'Global Express', 'World Bridge', 'Ocean Link', 'Port Royal', 'Cargo King',
  'Swift Current', 'Fast Lane', 'Prime Mover', 'Fleet Leader', 'Supply Chain',
  'Container Star', 'Freight Master', 'Bulk Carrier', 'Deep Draft', 'Heavy Lift',
  'Logistics One', 'Trade Route', 'Market Force', 'Commerce Bay', 'Export Star',
  // Historic / literary
  'Endurance', 'Discovery', 'Beagle', 'Bounty', 'Mayflower',
  'Santa Maria', 'Victoria', 'Kon-Tiki', 'Argo', 'Pequod',
  'Calypso', 'Nautilus', 'Nemo', 'Triton', 'Poseidon',
  'Aurora', 'Artemis', 'Athena', 'Orion', 'Perseus',
  // Company feel
  'Pioneer', 'Pathfinder', 'Wayfinder', 'Trailblazer', 'Frontrunner',
  'Cornerstone', 'Keystone', 'Capstone', 'Milestone', 'Benchmark',
  'Stalwart', 'Steadfast', 'Reliant', 'Resilient', 'Defiant',
  'Fortune', 'Providence', 'Prosperity', 'Abundance', 'Harvest',
  // Nature
  'Thunderbolt', 'Stormchaser', 'Lightning', 'Cyclone', 'Typhoon',
  'Avalanche', 'Glacier', 'Iceberg', 'Summit', 'Pinnacle',
  'Titan', 'Colossus', 'Leviathan', 'Behemoth', 'Goliath',
  'Falcon', 'Condor', 'Heron', 'Kestrel', 'Gannet',

  // More geography - straits & channels
  'Gibraltar', 'Dover', 'Skagerrak', 'Kattegat', 'Øresund',
  'English Channel', 'Strait of Hormuz', 'Taiwan Strait', 'Luzon Strait', 'Cook Strait',
  'Torres Strait', 'Bass Strait', 'Florida Straits', 'Denmark Strait', 'Bering Strait',
  'Strait of Juan de Fuca', 'Strait of Messina', 'Bonifacio', 'Bab-el-Mandeb', 'Lombok',

  // Capes & headlands
  'Cape Agulhas', 'Cape Finisterre', 'Cape Cod', 'Cape Fear', 'Cape Flattery',
  'Cape Hatteras', 'Cape Lookout', 'Cape May', 'Cape Race', 'Cape Sable',
  'Cape St. Vincent', 'Cape Verde', 'Cape Wrath', 'Cape York', 'North Cape',
  'Point Reyes', 'Point Conception', 'Lizard Point', 'Land\'s End', 'Europa Point',

  // Major seas & gulfs
  'Adriatic', 'Andaman', 'Arabian Sea', 'Azov', 'Barents',
  'Beaufort', 'Bering Sea', 'Black Sea', 'Caribbean', 'Celebes',
  'East China Sea', 'Gulf of Mexico', 'Gulf of Aden', 'Gulf of Alaska', 'Gulf of Bothnia',
  'Gulf of Finland', 'Gulf of Guinea', 'Gulf of Oman', 'Ionian Sea', 'Irish Sea',
  'Java Sea', 'Kara Sea', 'Laptev Sea', 'Ligurian Sea', 'Marmara',
  'Mediterranean', 'North Sea', 'Norwegian Sea', 'Philippine Sea', 'Red Sea',
  'Ross Sea', 'Sargasso', 'Scotia Sea', 'Sea of Japan', 'Sea of Okhotsk',
  'South China Sea', 'Tasman Sea', 'Timor Sea', 'Tyrrhenian Sea', 'Yellow Sea',

  // Ocean currents
  'Agulhas Current', 'Canary Current', 'East Australian', 'Equatorial Current', 'Humboldt',
  'Labrador Current', 'North Atlantic Drift', 'Peru Current', 'California Current', 'Brazil Current',

  // Rivers (major ports)
  'Thames', 'Seine', 'Rhine', 'Elbe', 'Oder',
  'Danube', 'Dnieper', 'Don', 'Volga', 'Neva',
  'Tagus', 'Guadalquivir', 'Tiber', 'Po', 'Rhone',
  'Scheldt', 'Mersey', 'Clyde', 'Tyne', 'Humber',
  'Hudson', 'Delaware', 'Savannah', 'Mississippi', 'Columbia',
  'St. Lawrence', 'Yangtze', 'Pearl River', 'Mekong', 'Chao Phraya',
  'Ganges', 'Indus', 'Shatt al-Arab', 'Nile', 'Congo',

  // Cities & ports
  'Rotterdam', 'Antwerp', 'Hamburg', 'Bremen', 'Amsterdam',
  'Copenhagen', 'Stockholm', 'Oslo', 'Bergen', 'Helsinki',
  'Gdansk', 'Riga', 'Tallinn', 'St. Petersburg', 'Marseille',
  'Barcelona', 'Valencia', 'Genoa', 'Trieste', 'Venice',
  'Naples', 'Palermo', 'Athens', 'Istanbul', 'Izmir',
  'Alexandria', 'Port Said', 'Jeddah', 'Dubai', 'Mumbai',
  'Karachi', 'Colombo', 'Chennai', 'Kolkata', 'Chittagong',
  'Singapore', 'Penang', 'Bangkok', 'Manila', 'Hong Kong',
  'Shanghai', 'Qingdao', 'Tianjin', 'Dalian', 'Busan',
  'Tokyo', 'Yokohama', 'Osaka', 'Kobe', 'Nagoya',
  'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Auckland',
  'New York', 'Boston', 'Baltimore', 'Charleston', 'Miami',
  'New Orleans', 'Houston', 'Long Beach', 'Oakland', 'Seattle',
  'Vancouver', 'Montreal', 'Halifax', 'Buenos Aires', 'Rio de Janeiro',
  'Santos', 'Valparaiso', 'Lima', 'Guayaquil', 'Cartagena',
  'Havana', 'Kingston', 'Panama City', 'Cape Town', 'Durban',
  'Lagos', 'Mombasa', 'Dar es Salaam', 'Port Louis', 'Maputo',

  // Gemstones & precious materials
  'Diamond', 'Emerald', 'Ruby', 'Sapphire', 'Topaz',
  'Amethyst', 'Garnet', 'Opal', 'Pearl', 'Jade',
  'Onyx', 'Amber', 'Coral', 'Turquoise', 'Lapis',
  'Platinum', 'Gold', 'Silver', 'Bronze', 'Copper',
  'Titanium', 'Palladium', 'Rhodium', 'Iridium', 'Osmium',
  'Obsidian', 'Quartz', 'Beryl', 'Aquamarine', 'Citrine',

  // Stars & constellations
  'Sirius', 'Canopus', 'Arcturus', 'Vega', 'Capella',
  'Rigel', 'Procyon', 'Achernar', 'Betelgeuse', 'Altair',
  'Aldebaran', 'Antares', 'Spica', 'Pollux', 'Fomalhaut',
  'Deneb', 'Regulus', 'Castor', 'Bellatrix', 'Elnath',
  'Andromeda', 'Aquarius', 'Aquila', 'Aries', 'Auriga',
  'Canis Major', 'Canis Minor', 'Capricorn', 'Cassiopeia', 'Centaurus',
  'Cetus', 'Columba', 'Corona', 'Corvus', 'Crux',
  'Cygnus', 'Delphinus', 'Draco', 'Gemini', 'Hercules',
  'Hydra', 'Leo', 'Libra', 'Lyra', 'Ophiuchus',
  'Pegasus', 'Phoenix', 'Pisces', 'Sagittarius', 'Scorpio',
  'Taurus', 'Ursa Major', 'Ursa Minor', 'Virgo', 'Centauri',

  // Mythology - Greek
  'Achilles', 'Ajax', 'Amphitrite', 'Andromache', 'Aphrodite',
  'Apollo', 'Ariadne', 'Asclepius', 'Atalanta', 'Atlas',
  'Boreas', 'Castor II', 'Circe', 'Daedalus', 'Demeter',
  'Dionysus', 'Eos', 'Eris', 'Eros', 'Galatea',
  'Hades', 'Hecate', 'Helios', 'Hephaestus', 'Hera',
  'Hermes', 'Hyperion', 'Icarus', 'Jason', 'Medea',
  'Medusa', 'Minos', 'Nereid', 'Nike', 'Oceanus',
  'Odysseus', 'Orpheus', 'Pan', 'Pandora', 'Penelope',
  'Persephone', 'Prometheus', 'Proteus', 'Scylla', 'Selene',
  'Theseus', 'Thetis', 'Ulysses', 'Zeus', 'Zephyr',

  // Mythology - Norse
  'Aegir', 'Asgard', 'Balder', 'Bifrost', 'Bor',
  'Freya', 'Freyr', 'Frigg', 'Heimdall', 'Hel',
  'Hodr', 'Idunn', 'Jormungandr', 'Loki', 'Midgard',
  'Mjolnir', 'Njord', 'Odin', 'Ragnarok', 'Ran',
  'Sif', 'Skadi', 'Thor', 'Tyr', 'Valhalla',
  'Valkyrie', 'Vidar', 'Yggdrasil', 'Sleipnir', 'Fenrir',

  // Mythology - Roman
  'Aeneas', 'Bellona', 'Ceres', 'Diana', 'Fortuna',
  'Janus', 'Juno', 'Jupiter', 'Mars', 'Mercury',
  'Minerva', 'Neptune', 'Pluto', 'Romulus', 'Saturn',
  'Venus', 'Vesta', 'Vulcan', 'Remus', 'Quirinus',

  // Birds
  'Eagle', 'Harrier', 'Merlin', 'Peregrine', 'Goshawk',
  'Buzzard', 'Kite', 'Sparrowhawk', 'Nighthawk', 'Seahawk',
  'Kingfisher', 'Tern', 'Gull', 'Skua', 'Fulmar',
  'Shearwater', 'Booby', 'Frigatebird', 'Tropicbird', 'Jaeger',
  'Auk', 'Murre', 'Puffin', 'Guillemot', 'Razorbill',
  'Crane', 'Ibis', 'Stork', 'Flamingo', 'Spoonbill',
  'Swan', 'Goose', 'Duck', 'Mallard', 'Widgeon',
  'Teal', 'Pintail', 'Merganser', 'Eider', 'Scoter',

  // Weather & natural phenomena
  'Aurora Borealis', 'Aurora Australis', 'Chinook', 'Doldrums', 'Equinox',
  'Gale', 'Squall', 'Maelstrom', 'Whirlpool', 'Waterspout',
  'Trade Winds', 'Westerlies', 'Roaring Forties', 'Furious Fifties', 'Screaming Sixties',
  'Polar Vortex', 'Jet Stream', 'El Niño', 'La Niña', 'Harmattan',
  'Zephyrus', 'Boreas Wind', 'Notus', 'Eurus', 'Bora',
  'Levanter', 'Meltemi', 'Gregale', 'Libeccio', 'Tramontane',
  'Föhn', 'Pampero', 'Southerly Buster', 'Fremantle Doctor', 'Cape Doctor',
  'Nor\'easter', 'Norther', 'Tehuantepecer', 'Papagayo', 'Chubasco',

  // Power & strength words
  'Invincible', 'Indomitable', 'Indefatigable', 'Unconquerable', 'Unbreakable',
  'Mighty', 'Powerful', 'Formidable', 'Tremendous', 'Magnificent',
  'Majestic', 'Imperial', 'Regal', 'Royal', 'Noble',
  'Brave', 'Bold', 'Fearless', 'Dauntless', 'Undaunted',
  'Champion', 'Victor', 'Conqueror', 'Dominator', 'Commander',
  'Guardian', 'Protector', 'Defender', 'Sentinel', 'Warden',
  'Avenger', 'Warrior', 'Gladiator', 'Centurion', 'Legion',
  'Phalanx', 'Vanguard II', 'Spearhead', 'Vanguard III', 'Advance Guard',

  // Speed & motion
  'Velocity', 'Momentum', 'Acceleration', 'Rapid', 'Quick',
  'Flash', 'Dart', 'Sprint', 'Rush', 'Dash',
  'Bolt', 'Arrow', 'Rocket', 'Comet', 'Meteor',
  'Quicksilver', 'Mercury II', 'Hermes II', 'Fleet', 'Nimble',
  'Agile', 'Swift II', 'Speedy', 'Express II', 'Flyer',
  'Racer', 'Speedster', 'Sprinter', 'Runner', 'Courier',

  // Colors + nautical terms
  'Azure Wave', 'Crimson Tide', 'Emerald Sea', 'Golden Wave', 'Jade Current',
  'Sapphire Horizon', 'Ruby Crest', 'Amber Swell', 'Violet Storm', 'Indigo Deep',
  'Silver Wave', 'Bronze Breaker', 'Platinum Wake', 'Copper Wave', 'Iron Tide',
  'Scarlet Sail', 'Cobalt Bay', 'Turquoise Dream', 'Coral Reef', 'Pearl Harbor',
  'Ivory Coast', 'Ebony Star', 'Grey Ghost', 'White Crest', 'Black Tide',
  'Green Wave', 'Blue Water', 'Red Dawn', 'Gold Rush', 'Silver Lining',

  // Two-word combos - adjective + maritime noun
  'Ancient Mariner', 'Bold Navigator', 'Brave Sailor', 'Brilliant Star', 'Celestial Navigator',
  'Distant Shore', 'Eastern Promise', 'Eternal Voyage', 'Far Horizon', 'Flying Dutchman',
  'Golden Fleece', 'Grand Mariner', 'Great Barrier', 'Hidden Treasure', 'High Tide',
  'Immortal Wave', 'Infinite Ocean', 'Lone Voyager', 'Lost Horizon', 'Lucky Star',
  'Midnight Sun', 'Morning Star', 'Noble Quest', 'Ocean Monarch', 'Pacific Voyager',
  'Phantom Ship', 'Proud Mary', 'Restless Sea', 'Rising Sun', 'Rolling Thunder',
  'Sacred Anchor', 'Seven Seas', 'Silent Wave', 'Southern Cross', 'Starlight Express',
  'Stormy Petrel', 'Sunrise', 'Sunset', 'Tall Ship', 'Twilight Zone',
  'Wandering Star', 'Western Wind', 'Wild Wave', 'Wind Dancer', 'Windward Passage',

  // Historic vessels & explorers
  'Adventure', 'Astrolabe', 'Britannia', 'Challenge', 'Challenger',
  'Cutty Sark', 'Duyfken', 'Eagle II', 'Erebus', 'Flying Cloud',
  'Golden Hind', 'Great Eastern', 'Great Republic', 'Half Moon', 'Herald',
  'James Caird', 'La Salle', 'Lusitania', 'Mary Celeste', 'Niña',
  'Pinta', 'Queen Mary', 'Rainbow Warrior', 'Resolution', 'Sea Witch',
  'Titanic', 'Terror', 'United States', 'Vasa', 'Wanderer',
  'Columbus', 'Magellan II', 'Cook', 'Vasco da Gama', 'Cabot',
  'Vespucci', 'Balboa', 'Cortez', 'Pizarro', 'Drake II',
  'Raleigh', 'Hudson II', 'Bering', 'Tasman', 'La Perouse',

  // Company & enterprise terms
  'Enterprise', 'Industries', 'Ventures', 'Holdings', 'Partners',
  'Alliance', 'Coalition', 'Consortium', 'Federation', 'Union',
  'Guild', 'Company', 'Corporation', 'Syndicate', 'Association',
  'Initiative', 'Endeavor', 'Project', 'Mission', 'Operation',
  'Strategy', 'Vision', 'Legacy', 'Heritage', 'Dynasty',
  'Empire', 'Domain', 'Realm', 'Kingdom', 'Commonwealth',
  'Republic', 'State', 'Nation', 'Territory', 'Province',

  // Modern shipping terms
  'Container Express', 'Cargo Express', 'Freight Express', 'Trade Express', 'Commerce Express',
  'Global Trader', 'Ocean Trader', 'Sea Trader', 'World Trader', 'Continental Trader',
  'Pacific Carrier', 'Atlantic Carrier', 'Global Carrier', 'World Carrier', 'Ocean Carrier',
  'Maritime Star', 'Shipping Star', 'Trading Star', 'Cargo Star', 'Freight Star',
  'Port Star', 'Harbor Star', 'Bay Star', 'Coast Star', 'Channel Star',
  'Bulk Express', 'Container King', 'Tanker King', 'Shipping King', 'Maritime King',
  'Ocean King', 'Sea King', 'Trade King', 'Merchant King', 'Fleet King',
  'Logistics Express', 'Supply Express', 'Chain Express', 'Distribution Express', 'Transport Express',
  'Maritime Venture', 'Ocean Venture', 'Sea Venture', 'Trade Venture', 'Cargo Venture',
  'Global Venture', 'World Venture', 'Pacific Venture', 'Atlantic Venture', 'Continental Venture',

  // Achievement & success terms
  'Achievement', 'Success', 'Victory', 'Triumph', 'Glory',
  'Excellence', 'Prestige', 'Distinction', 'Honor', 'Pride',
  'Celebration', 'Jubilee', 'Festival', 'Gala', 'Carnival',
  'Pinnacle II', 'Apex', 'Zenith', 'Acme', 'Peak',
  'Crown', 'Jewel', 'Prize', 'Trophy', 'Medal',
  'Award', 'Laureate', 'Champion II', 'Winner', 'Leader',

  // Classic ship prefixes + nouns
  'Sea Sprite', 'Ocean Spirit', 'Wave Rider', 'Wind Seeker', 'Storm Rider',
  'Tide Runner', 'Current Chaser', 'Wave Dancer', 'Sea Dancer', 'Ocean Wanderer',
  'Sea Wanderer', 'Wave Wanderer', 'Wind Wanderer', 'Storm Wanderer', 'Tide Wanderer',
  'Ocean Runner', 'Sea Runner', 'Wave Runner', 'Wind Runner', 'Storm Runner',
  'Tide Seeker', 'Ocean Seeker', 'Sea Seeker', 'Wave Seeker', 'Storm Seeker',
  'Wind Chaser', 'Tide Chaser', 'Ocean Chaser', 'Sea Chaser', 'Wave Chaser',
  'Ocean Dreamer', 'Sea Dreamer', 'Wave Dreamer', 'Wind Dreamer', 'Storm Dreamer',
  'Tide Master', 'Ocean Master', 'Sea Master', 'Wave Master', 'Wind Master',
  'Storm Master', 'Current Master', 'Breeze Master', 'Gale Master', 'Tempest Master',

  // Virtues & qualities
  'Harmony', 'Serenity', 'Tranquility', 'Peace', 'Calm',
  'Wisdom', 'Knowledge', 'Insight', 'Enlightenment', 'Understanding',
  'Justice', 'Equity', 'Fairness', 'Balance', 'Order',
  'Liberty', 'Freedom', 'Independence', 'Autonomy', 'Sovereignty',
  'Unity', 'Solidarity', 'Brotherhood', 'Fellowship', 'Kinship',
  'Hope', 'Faith', 'Charity', 'Grace', 'Mercy',
  'Patience', 'Diligence', 'Perseverance', 'Determination', 'Tenacity',
  'Integrity', 'Honesty', 'Truth', 'Loyalty', 'Fidelity',
  'Courage', 'Bravery', 'Valor', 'Gallantry', 'Heroism',

  // Marine animals
  'Dolphin', 'Porpoise', 'Orca', 'Whale', 'Narwhal',
  'Manatee', 'Dugong', 'Seal', 'Walrus', 'Otter',
  'Barracuda', 'Marlin', 'Swordfish', 'Tuna', 'Mako',
  'Hammerhead', 'Manta', 'Stingray', 'Octopus', 'Squid',
  'Kraken', 'Cuttlefish', 'Nautilus II', 'Conch', 'Triton II',

  // Wind & sailing terms
  'Headwind', 'Tailwind', 'Crosswind', 'Nor\'wester', 'Sou\'wester',
  'Fair Wind', 'Following Sea', 'Beam Reach', 'Close Hauled', 'Running Free',
  'Spinnaker', 'Mainsail', 'Jib', 'Mizzen', 'Topsail',
  'Full Sail', 'Half Mast', 'Steady Course', 'True Course', 'Great Circle',

  // Navigation terms
  'Bearing', 'Azimuth', 'Heading', 'Course', 'Track',
  'Waypoint', 'Landmark', 'Beacon', 'Lighthouse', 'Buoy',
  'Sextant', 'Chronometer', 'Astrolabe II', 'Quadrant', 'Navigator',
  'Chart', 'Compass', 'Compass II', 'Lodestone', 'Magnetic North',

  // Time & astronomy
  'Solstice', 'Equinox II', 'Meridian II', 'Nadir', 'Zenith II',
  'Dawn', 'Dusk', 'Twilight', 'Noon', 'Midnight',
  'Eclipse', 'New Moon', 'Full Moon', 'Crescent', 'Gibbous',
  'Spring Tide', 'Neap Tide', 'Ebb Tide', 'Flood Tide', 'Slack Water',

  // Ocean features
  'Trench', 'Abyss', 'Deep Blue', 'Ocean Floor', 'Continental Shelf',
  'Seamount', 'Guyot', 'Atoll', 'Lagoon', 'Reef',
  'Shoal', 'Bank', 'Sound', 'Fjord', 'Bay',
  'Cove', 'Harbor', 'Haven', 'Anchorage', 'Roadstead',

  // Precious cargo
  'Silk Road', 'Spice Route', 'Amber Road', 'Tea Clipper', 'China Trade',
  'East Indiaman', 'West Indiaman', 'Treasure Fleet', 'Merchant Adventurer', 'Trading Company',
  'Pepper Trader', 'Salt Carrier', 'Grain Hauler', 'Timber Ship', 'Coal Trader',

  // Island nations & territories
  'Malta', 'Cyprus', 'Crete', 'Sardinia', 'Sicily',
  'Corsica', 'Majorca', 'Ibiza', 'Minorca', 'Madeira',
  'Azores', 'Canaries', 'Iceland', 'Greenland', 'Faroe',
  'Orkney', 'Shetland', 'Hebrides', 'Bermuda', 'Bahamas',
  'Jamaica', 'Barbados', 'Trinidad', 'Tobago', 'Aruba',
  'Curacao', 'Martinique', 'Guadeloupe', 'Fiji', 'Samoa',
  'Tonga', 'Tahiti', 'Bora Bora', 'New Caledonia', 'Vanuatu',
  'Solomon', 'Maldives', 'Seychelles', 'Mauritius', 'Zanzibar',

  // Metals & minerals
  'Zinc', 'Nickel', 'Chromium', 'Cobalt', 'Manganese',
  'Tungsten', 'Molybdenum', 'Vanadium', 'Lead', 'Tin',
  'Aluminum', 'Bauxite', 'Graphite', 'Mica', 'Feldspar',

  // Colors - pure
  'Crimson', 'Scarlet', 'Vermillion', 'Cerulean', 'Ultramarine',
  'Navy', 'Verdigris', 'Aqua', 'Cyan', 'Turquoise II',
  'Viridian', 'Chartreuse', 'Ochre', 'Sienna', 'Umber',

  // Final legendary & mythical ships
  'Ark Royal', 'Golden Age', 'Age of Discovery', 'Renaissance', 'New Dawn',
  'Industrial', 'Progress', 'Advancement', 'Innovation', 'Revolution',
  'Evolution', 'Genesis', 'Exodus', 'Odyssey', 'Epic',
  'Saga', 'Legend', 'Myth', 'Fable', 'Tale',
  'Chronicle', 'History', 'Destiny', 'Fate', 'Fortune II',
  'Kismet', 'Karma', 'Dharma', 'Nirvana', 'Elysium',
  'Avalon', 'Camelot', 'Shangri-La', 'Utopia', 'Paradise',
  'Eden', 'Arcadia', 'Olympus', 'Valhalla II', 'Asgard II'
];

const _used = new Set();

/** Pick a random unused ship name. Resets pool when exhausted. */
export function pickShipName() {
  if (_used.size >= SHIP_NAMES.length) _used.clear();
  const available = SHIP_NAMES.filter(n => !_used.has(n));
  const name = available[Math.floor(random() * available.length)];
  _used.add(name);
  return name;
}

/** Mark a name as used (call when loading saved ships). */
export function markNameUsed(name) {
  _used.add(name);
}
